<template>
  <div class="image-attach">
    <img :id="uFileId" :src="uFilePath + '?imageMogr/auto-orient'" @click="previewImg">
  </div>

</template>

<script type="text/ecmascript-6">
  import 'viewerjs/dist/viewer.css'
  import Viewer from 'viewerjs'
  import mixin from './attachMixin'
  

  export default {
    mixins: [mixin],
    mounted() {
      this.previewImg()
    },
    methods: {
      initPage: function () {
        let self = this
      },
      previewImg: function () {
        let self = this
        const viewer = new Viewer(document.getElementById(self.uFileId), {
          fullscreen: true,
          toolbar: false,
          navbar: false,
          title: false,
          viewed() {
            viewer.zoomTo(1);
          },
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .image-attach{
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/components/uAttach/uImageAttach.vue